var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReports(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    stroke: "white",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 2C3.16421 2 3.5 2.33579 3.5 2.75V18.4528H19.2028C19.617 18.4528 19.9528 18.7886 19.9528 19.2028C19.9528 19.617 19.617 19.9528 19.2028 19.9528H2.75C2.33579 19.9528 2 19.617 2 19.2028V2.75C2 2.33579 2.33579 2 2.75 2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97644 13.4079L9.06902 8.76527C9.07372 8.75954 9.08274 8.76048 9.08615 8.76705L11.6181 13.3571C11.6317 13.3816 11.6656 13.385 11.6837 13.3636L17.3159 6.70732M17.3159 6.70732L14.2537 6.70735M17.3159 6.70732V9.79991",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.27e860ff.svg";
export { ForwardRef as ReactComponent };